var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6698 1.99921H16.3398C19.7298 1.99921 21.9998 4.37921 21.9998 7.91921V16.0902C21.9998 19.6202 19.7298 21.9992 16.3398 21.9992H7.6698C4.2798 21.9992 1.9998 19.6202 1.9998 16.0902V7.91921C1.9998 4.37921 4.2798 1.99921 7.6698 1.99921ZM15.0098 14.9992C15.3498 14.6602 15.3498 14.1102 15.0098 13.7702L13.2298 11.9902L15.0098 10.2092C15.3498 9.87021 15.3498 9.31021 15.0098 8.97021C14.6698 8.62921 14.1198 8.62921 13.7698 8.97021L11.9998 10.7492L10.2198 8.97021C9.8698 8.62921 9.3198 8.62921 8.9798 8.97021C8.6398 9.31021 8.6398 9.87021 8.9798 10.2092L10.7598 11.9902L8.9798 13.7602C8.6398 14.1102 8.6398 14.6602 8.9798 14.9992C9.1498 15.1692 9.3798 15.2602 9.5998 15.2602C9.8298 15.2602 10.0498 15.1692 10.2198 14.9992L11.9998 13.2302L13.7798 14.9992C13.9498 15.1802 14.1698 15.2602 14.3898 15.2602C14.6198 15.2602 14.8398 15.1692 15.0098 14.9992Z",
    fill: "#8C9FB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.be852152ecf4924e896e875f74853daa.svg";
export { ForwardRef as ReactComponent };